<template>
  <div class="mainWrap">
    <div class="outMain">
      <div class="mainLeft">
        <slot name="left"></slot>
      </div>
      <div class="mainRight">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "left-right"
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainWrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .outMain {
      width: 890px;
      height: 710px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mainLeft, .mainRight {
        height: 100%;
        display: flex;
        color: $color_white;
        background-color: $block_bg_color_base;
      }
      .mainLeft {
        width: 200px;
      }
      .mainRight {
        width: 670px;
      }
    }
  }
</style>